const LINK_STATES = {
  newLink: 'newLink',
  loading: 'loading',
  linkChecked: 'linkChecked',
};

export { LINK_STATES };
